import { render } from "./DocumentDialogPreview.vue?vue&type=template&id=e2c2e3b4&scoped=true"
import script from "./DocumentDialogPreview.vue?vue&type=script&lang=js"
export * from "./DocumentDialogPreview.vue?vue&type=script&lang=js"

import "./DocumentDialogPreview.vue?vue&type=style&index=0&id=e2c2e3b4&scoped=true&lang=scss"

import exportComponent from "/tmp/5e119732-5ebd-42f7-baa8-4916aa59fc29/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2c2e3b4"]])

export default __exports__